import EcommerceSignalMetricChangeDirection from "../EcommerceSignalMetricChangeDirection";

type EcommerceSignalMetricChangeDirectionValue =
    (typeof EcommerceSignalMetricChangeDirection)[keyof typeof EcommerceSignalMetricChangeDirection];

export const isEcommerceSignalMetricChangeDirection = (
    value: string,
): value is EcommerceSignalMetricChangeDirectionValue =>
    value === EcommerceSignalMetricChangeDirection.Grew ||
    value === EcommerceSignalMetricChangeDirection.Declined;
